/**
 * Resolves a Contentful asset reference (or embedded asset) to a full asset entry.
 */
export const resolveContentfulAsset = (assetLink, includes) => {
  if (!assetLink) return null;
  if (assetLink.fields?.file) return assetLink;

  const id = assetLink.sys?.id;
  if (!id || !includes?.Asset) return null;

  return includes.Asset.find((asset) => asset.sys.id === id) || null;
};

export const getAssetUrl = (asset) => {
  const url = asset?.fields?.file?.url;
  if (!url) return null;
  return url.startsWith("//") ? `https:${url}` : url;
};

/** Parses sponsor website URL from asset Description or JSON `url` field. */
export const parseSponsorUrl = (raw) => {
  const value = typeof raw === "string" ? raw.trim() : "";
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  if (/^[\w.-]+\.[a-z]{2,}(\/\S*)?$/i.test(value)) return `https://${value}`;
  return null;
};

export const mapContentfulGallery = (galleryField, includes) => {
  if (!Array.isArray(galleryField) || galleryField.length === 0) return [];

  return galleryField
    .map((item) => {
      const asset = resolveContentfulAsset(item, includes);
      const src = getAssetUrl(asset);
      if (!src) return null;

      return {
        src,
        alt: asset.fields?.description || asset.fields?.title || "Meet photo",
      };
    })
    .filter(Boolean);
};

export const mapContentfulSponsors = (sponsorsField, includes) => {
  if (!Array.isArray(sponsorsField) || sponsorsField.length === 0) return [];

  return sponsorsField
    .map((item) => {
      const asset = resolveContentfulAsset(item, includes);
      const logoUrl = getAssetUrl(asset);
      const name = asset?.fields?.title || "Partner";
      const url = parseSponsorUrl(asset?.fields?.description);

      if (logoUrl) {
        return { name, logoUrl, url };
      }
      return { name, logoUrl: null, url: null };
    })
    .filter(Boolean);
};
